module.exports = __webpack_public_path__ + "img/tg-logo.95660f34.png";